import { FetchResult } from 'src/types/TApiQueries';
import {
  DestinationsResponse,
  DestinationType,
  UpsertDestinationPayload,
  TestDestinationPayload,
  TestDestinationResult,
} from 'src/types/TAnalyticsDestinations';
import { config } from 'src/utils/config';
import { getStandardHeaders, performFetchWithLogging } from '../utils/helpers';

const baseUrl = config.hostUrl;
const root = `${baseUrl}/api/v1/insights/destinations`;

export async function getDestinations(
  accessToken: string,
): Promise<FetchResult<DestinationsResponse>> {
  return performFetchWithLogging(root, {
    method: 'GET',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export async function upsertDestination(
  payload: UpsertDestinationPayload,
  accessToken: string,
): Promise<FetchResult<DestinationsResponse>> {
  return performFetchWithLogging(root, {
    method: 'POST',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(payload),
  });
}

export async function setDestinationEnabled(
  destinationType: DestinationType,
  enabled: boolean,
  accessToken: string,
): Promise<FetchResult<DestinationsResponse>> {
  return performFetchWithLogging(`${root}/${destinationType}`, {
    method: 'PUT',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify({ enabled }),
  });
}

export async function deleteDestination(
  destinationType: DestinationType,
  accessToken: string,
): Promise<FetchResult<DestinationsResponse>> {
  return performFetchWithLogging(`${root}/${destinationType}`, {
    method: 'DELETE',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export async function testDestination(
  payload: TestDestinationPayload,
  accessToken: string,
): Promise<FetchResult<TestDestinationResult>> {
  return performFetchWithLogging(`${root}/test`, {
    method: 'POST',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(payload),
  });
}
